import {createApp} from 'vue';

import 'primeicons/primeicons.css';
import './assets/_breakpoints.scss';
import './assets/_mixins.scss';

import App from '@/App.vue';
import { createPinia } from 'pinia';
import PrimeVue from 'primevue/config';
// eslint-disable-next-line import/no-unresolved
import Aura from '@primevue/themes/aura';
// eslint-disable-next-line import/no-unresolved
import {definePreset} from "@primevue/themes";
import Tooltip from 'primevue/tooltip';
import ToastService from 'primevue/toastservice';

import {ConfirmationService} from "primevue";
import router from './router'

const MyPreset = definePreset(Aura, {
    semantic: {
        primary: {
            50: '{slate.50}',
            100: '{slate.100}',
            200: '{slate.200}',
            300: '{slate.300}',
            400: '{slate.400}',
            500: '{slate.500}',
            600: '{slate.600}',
            700: '{slate.700}',
            800: '{slate.800}',
            900: '{slate.900}',
            950: '{slate.950}'
        },
        colorScheme: {
            light: {
                surface: {
                    0: '#fff',
                    50: '{slate.50}',
                    100: '{slate.100}',
                    200: '{slate.200}',
                    300: '{slate.300}',
                    400: '{slate.400}',
                    500: '{slate.500}',
                    600: '{slate.600}',
                    700: '{slate.700}',
                    800: '{slate.800}',
                    900: '{slate.900}',
                    950: '{slate.950}'
                }
            },
            dark: {
                surface: {
                    0: '#fff',
                    50: '{slate.50}',
                    100: '{slate.100}',
                    200: '{slate.200}',
                    300: '{slate.300}',
                    400: '{slate.400}',
                    500: '{slate.500}',
                    600: '{slate.600}',
                    700: '{slate.700}',
                    800: '{slate.800}',
                    900: '{slate.900}',
                    950: '{slate.950}'
                }
            }
        }
    },
    components: {
        scrollpanel: {
            colorScheme: {
                light: {
                    bar: {
                        background: '{surface.300}',
                    },
                },
                dark: {
                    bar: {
                        background: '{surface.300}',
                    },
                }
            }
        },
    }
});
const app = createApp(App);
app.directive('tooltip', Tooltip);
app.use(createPinia());
app.use(router);
app.use(PrimeVue, {
    theme: {
        preset: MyPreset,
        options: {
            prefix: 'p',
            darkModeSelector: '.my-app-dark',
            cssLayer: false
        }
    }
});
app.use(ToastService);
app.use(ConfirmationService);
app.mount('#chat-widget');
